import { Button, Icon } from '@yembo/yemblocks-core';
import dayjs from 'dayjs';
import Dedupe from 'src/assets/svg/dedupe.svg?react';
import { CompanyDefaultSurveyType, Insured } from 'src/types';

type Props = {
  isAddingContact: boolean;
  isResendingInvite: boolean;
  insured: null | Insured;
  isInvite: boolean;
  onBack: () => void;
  onGoToJob: () => void;
  onCreate: () => void;
  resendInvite: () => void;
  surveyType: CompanyDefaultSurveyType;
};

export const SubmitMessage = ({
  isAddingContact,
  isResendingInvite,
  insured,
  isInvite,
  onBack,
  onGoToJob,
  resendInvite,
  onCreate,
  surveyType,
}: Props) => (
  <div className={`submit-message ${insured ? 'duplicate' : ''}`}>
    {insured ? (
      <>
        <div className='inline flex-center'>
          <span className='sub-title'>Potential duplicate found!</span>
        </div>
        <div className='flex-center'>
          <Dedupe className='is-invalid' />
        </div>
        <div className='inline flex-center duplicate-message'>
          <p>
            {insured.givenName} {insured.familyName} already has a survey created on&nbsp;
            {dayjs(insured.createdAt).format('LLL')}
          </p>
        </div>
        <div className='column buttons flex-center'>
          <Button
            onClick={isInvite ? resendInvite : onGoToJob}
            text={isInvite ? 'Resend Existing Invite' : 'Go to Existing Survey'}
            isLoading={isInvite && isResendingInvite}
            isDisabled={isAddingContact}
          />
          <Button
            isDisabled={isInvite && isResendingInvite}
            isLoading={isAddingContact}
            onClick={onCreate}
            text='Or, Create New Survey'
            kind='outline'
          />
        </div>
      </>
    ) : (
      <>
        <div className='flex-center success'>
          <Icon name='checkmark-circle' className='success-checkmark' />
          <p className='added'>Your contact has been added.</p>
        </div>
        <div className='column buttons flex-center'>
          <Button
            text={surveyType === 'manual_survey' ? 'View Contact / Schedule' : 'View Contact'}
            onClick={onGoToJob}
          />
          <Button kind='outline' icon={<Icon name='add' />} text='Add Another' onClick={onBack} />
        </div>
      </>
    )}
  </div>
);
